import React from 'react';

const Before20250701Terms = () => (
  <div>
    {`2025年7月1日改訂

マイヒルズショップ（獣医師用サイト） 利用規程

マイヒルズショップ（獣医師用サイト） 利用規程（以下「本規程」といいます。）は、
日本ヒルズ・コルゲート株式会社及びその関係会社（以下、あわせて「当社」といいます
。）が運営するマイヒルズショップ（獣医師用サイト）（以下「本サイト」といいます。
）の利用に関する当社と専門家（第2条に定義します。以下同じ。）との間の取引に適用さ
れる条件を定めるものです。本サイトをご利用いただく前に、本規程の全文をお読みにな
り、本規程に同意していただく必要があります。専門家が本サイトをご利用された場合、
本規程に同意したものとみなされます。

第1条（規程の適用）
1. 本規程は、専門家と当社との間の本サイトのご利用に関わる一切の関係に適用されま
す。
2. 当社は、専門家による本サイトの利用に関して、本規程のほか、各種特約、その他の
ガイドライン等（以下「特約等」といいます。）を定めることがあります。これらの
特約等は、本規程の一部を構成するものとします。
3. 本規程の内容と、特約等の内容とが異なる場合は、別段の定めがない限り、本規程の
規定が優先して適用されるものとします。

第2条（用語の定義）
本規程において使用する以下の各号の用語は、それぞれ以下の各号に定める意味を有する
ものとします。
(1) 「知的財産権」とは、著作権、特許権、実用新案権、意匠権、商標権その他の知的財
産権（それらの権利を取得し、又はそれらの権利につき登録等を出願する権利を含み
ます。）をいいます。
(2) 「マイヒルズショップ」とは、当社が運営するマイヒルズショップをいいます。
(3) 「専門家」とは、日本国内でその開設が行政当局に有効に届け出られている飼育動物
診療施設（動物病院）、及び当該動物病院に勤務等をする獣医師又は動物看護師であ
って、本サービスを利用する個人又は当該獣医師が所属する法人をいいます。
(4) 「ユーザー」とは、マイヒルズショップを利用して製品を購入し、又は購入しようと
するユーザー（個人又は法人の別を問いません。）をいいます。

第3条（本サービスの利用）
1. 専門家による本規程の遵守を条件として、当社は専門家に対し、個人的な利用のため
、本サイト上で当社が提供するサービス（以下「本サービス」といいます。）にアク
セスする限定的、個人的、非独占的かつ譲渡不可の権利を許諾します。専門家は、本
規程にて明示的に許諾された権利を除き、その他の権利を得ることはできません。
2. 本サービスの対象は日本国内とします。
3. 専門家は、本サービスを利用するため、当社が定める必要な情報を当社に提供するも
のとします。

第4条（会員登録）
1. 本サービスを利用するためには会員登録が必要です（当該会員登録を行った専門家を
以下「会員」といいます。）。会員登録を希望する専門家（以下「登録希望者」とい
います。）は、本規程を遵守することに同意し、かつ当社の定める情報（メールアド
レス、所属動物病院に関する情報、銀行口座を含み、以下「登録事項」といいます。
）の登録を含む当社所定の方法により申し込むものとします。専門家は、所属動物病
院を代表して会員登録をする権限を有すること、登録事項が真実かつ正確であること
、専門家による登録事項に含まれる情報の使用が法令及び本規程に違反しないことを
、表明し保証します。
2. 登録希望者による会員としての登録は、登録希望者からの申込に対して当社が承諾す
る旨のメールを送信した時点をもって完了したものとします。
3. 当社は、会員が以下のいずれかに該当する場合、会員資格を取り消し、又は本サービ
スの利用を停止することができ、またその理由について開示義務を負いません。
   (1) 当社に提供した登録事項の全部又は一部につき虚偽、誤記又は記載漏れがあった
   とき
   (2) 第２条３号の規定に該当する獣医師又はその所属法人であることが確認できない
   場合
   (3) 成年被後見人、被保佐人又は被補助人のいずれかであり、法定代理人、後見人、
   保佐人又は補助人の同意等を得ていなかったとき
   (4) 反社会的勢力等（暴力団、暴力団員、暴力団準構成員、暴力団関係企業、総会屋
   等、社会運動等標ぼうゴロ、暴力団員でなくなってから5年を経過していない者
   、その他これらに準ずる者を意味します。以下同じ。）である、又は資金提供そ
   の他を通じて反社会的勢力等の維持、運営若しくは経営に協力若しくは関与する
   等反社会的勢力等との何らかの交流若しくは関与を行っていると当社が判断した
   とき
   (5) 会員が過去に当社との契約に違反した者又はその関係者であると当社が判断した
   とき
   (6) 第11条に定める措置を受けたことがあるとき
   (7) 本規程又は特約等に反する行為があったとき
   (8) その他、当社が登録を不適切と判断する事由があったとき

4. 会員は、登録事項に変更があった場合、当該変更事項を、当社の定める方法により遅
滞なく当社に届け出るものとします。会員が本項の届出を怠ったことにより当社から
会員への連絡、通知等が到達せず、又は遅延したことにより会員に損害が生じた場合
でも、当社は責任を負いません。

第5条（アカウント及びパスワード）
会員は、本サービスに関するアカウント及びパスワードを、自己の責任において、厳重に
管理するものとし、これを第三者に利用させ、又は貸与、譲渡、名義変更等をしてはなら
ないものとします。会員は、会員のアカウント及びパスワードを使用して実施されるすべ
ての行為の責任を負います。

第6条（商品の推奨等）
1. 当社は、会員に対し、以下のサービスを提供します。
   (1) ユーザーに対する製品の推奨連絡機能の提供
   (2) 会員を識別する当社所定のクリニックコードの提供
   (3) 会員が推奨連絡を行ったユーザー（以下「対象ユーザー」といいます。）に関す
   る情報（製品の購入日、購入内容、購入数量を含みます。）、及び当社から会員
   に支払われる商品の推奨手数料等の情報の提供
   (4) その他本規程等に基づき当社が提供するサービス
2. 会員は、本サービスを通じて、ユーザーに対しマイヒルズショップにおける製品の推
奨連絡等を行うものとします。
3. 当社は、本サービス向上のため、本サービスにて管理される会員及び対象ユーザーに
かかるマイヒルズショップ及び本サイトの利用等に関する情報を統計および分析等に
利用することができるものとし、専門家はこれに同意するものとします。

第７条（推奨手数料）
1. 当社は、対象ユーザーが、会員のクリニックコードを示してマイヒルズショップにお
いて製品の購入を行ったときは、会員に対し、当社が別途定める推奨手数料（以下「
推奨手数料」といいます。）を支払うものとします。
2. 推奨手数料の支払いは、当社が指示する決済サービスにおいて会員が適切な登録を行
うことを条件とします。決済サービスにおいて未登録の期間における対象ユーザーの
製品の購入について、会員は推奨手数料を受け取ることはできません。また、会員が
決済サービスに対し決済に必要な情報を提供しないこと、誤った登録情報を修正しな
いこと、または登録情報を最新の情報に更新しないことなどにより、当社が決済サー
ビスを使用して会員に対し推奨手数料を支払うことのできない事象が6ヶ月間継続した
場合、当該6ヶ月間の期間の満了をもって当社は当該推奨手数料を支払う義務を負わな
いものとします。
3. 当社は、前月末日から当月末日の前日までの期間（以下「計算期間」といいます。）
における対象ユーザーによる前項に定める製品購入代金を基礎として算出される推奨
手数料を、当該計算期間の当月末日までに、会員が当社に対して予め届け出た銀行口
座に振り込み送金する方法により支払います。振込に要する費用は当社の負担としま
す。

第8条（禁止行為）
1. 本サービスの利用にあたって、以下の各号のいずれかに該当する行為又は該当すると
当社が判断する行為（以下「禁止行為」といいます。）を行うことを禁止します。
   (1) 法令（獣医師法、愛玩動物看護師法、並びに医薬品、医療機器等の品質、有効性
   及び安全性の確保等に関する法律を含みますがこれらに限られません。）又は公
   序良俗に反する行為
   (2) 本規程及び特約等に違反する行為
   (3) 犯罪行為若しくは犯罪行為に結びつく行為又はそのおそれのある行為
   (4) 当社、本サービスの他の会員、ユーザー又はその他の第三者に対する詐欺又は脅
   迫行為
   (5) 当社、本サービスの他の会員、ユーザー又はその他の第三者の知的財産権、肖像
   権、プライバシーの権利、名誉、その他の権利又は利益を侵害する行為
   (6) 本サービスを又は本サイトを複製し、又は改変する行為
   (7) 本サービスをリバースエンジニア、逆コンパイル、翻訳、分解することまたはソ
   ースコードを取り出す行為
   (8) 本サービスを第三者に対し頒布、提供、貸与、または譲渡しようとする行為
   (9) 本サービスと競合する製品又はサービスのため本サービスを利用する行為、また
   は当該目的で第三者に対しアクセスを許可する行為
   (10) 以下に該当し、又は該当すると当社が判断する情報を投稿し、もしくは当社又は
      ユーザーに送信する行為
   · 虚偽又は誤解を招くような内容を含む情報
   · 過度に暴力的、残虐又はわいせつな表現を含む情報
   · 反社会的な表現を含む情報
   · コンピューター・ウィルスその他の有害なコンピューター・プログラムを含
   む情報
   · 当社、他の会員、ユーザー、その他の第三者を脅迫し、又はその名誉や信用
   を毀損する表現を含む情報、
   · 当社、他の会員、ユーザー、その他第三者の知的財産権その他の権利を侵害
   する表現を含む情報
   · 勧誘、チェーンメール又はその他あらゆるスパムを含む情報
   (11) 本サービスの運営を妨げる恐れのある行為（本サービスのシステム等に不正にア
   クセスし、過度な負荷をかける行為を含みます。）、又は当社の信用を毀損する
   おそれのある行為
   (12) 当社又は第三者に成りすます行為
   (13) 本サービスのアカウント若しくはパスワードの不正利用、又は他の専門家若しく
   は第三者に使用させる行為
   (14) 他の専門家又はユーザー（対象ユーザーを除きます。）の個人情報を収集、蓄積
   又は保存する行為
   (15) 同一の会員が会員登録を複数回行い、同時に複数のアカウントを保有する行為
   (16) 当社、本サービスの他の会員、ユーザー又はその他の第三者に不利益、損害、不
   快感を与える行為
   (17) 当社又は本サービスの信用を著しく失墜させるおそれがある行為
   (18) 製品が医薬品的効能効果を有するものと誤認させ、又は実際のものより著しく優
   良・有利であるとユーザーに誤認させる内容を含む情報を提供または掲載するこ
   と
   (19) 当社の事前の書面による承諾なくして、推奨連絡その他の本サイト上の投稿等に
   おいて、他のウェブサイト（会員の所属する動物病院を除きます。以下同じ。）
   への外部リンクの設置、メールマガジンまたは書面等手段を問わず、本サイトを
   通じて申し込まれた対象ユーザーに対する他のウェブサイトへの誘導告知および
   これらに付随する誘導告知や宣伝の記載等、当社の営業活動に影響を及ぼし、ま
   たはそのおそれのある行為
   (20) 各検索サイトにおいて、第三者が運営するウェブサイトやサービスの名称、また
   は第三者が保有する登録商標等をキーワードとして、本サイトへ誘導するリステ
   ィング広告を行う等のユーザーの誤解を招く宣伝・広告を行うこと
   (21) 前各号の行為を直接又は間接に惹起し、又は容易にする行為
   (22) その他、当社が不適切と判断する行為
2. 専門家が前項各号のいずれかに該当したときは、当社は、何らの催告を要することな
く、第11条に従い、推奨手数料の支払停止、本サービスの利用停止、専門家との契約
の解除、会員資格を取消し、当該会員資格に関する一切の情報の削除その他の当社が
適当と判断する措置を講じることができるものとします。

第9条（本サービスの停止及び中断）
1. 当社は、以下の各号のいずれかに該当する場合、専門家に事前の告知なく、本サービ
スの全部又は一部の提供を停止又は中断することができるものとします。
   (1) 本サービスに関するシステムの保守、点検、修理作業を行う場合
   (2) 当社の責めに帰する事由によらずにシステム、通信回線等が停止した場合
   (3) 地震、落雷、火災、風水害、停電、天災地変等の不可抗力により、本サービ
   スの提供が困難又は不可能になった場合
   (4) 本サービス提供のためのシステム不良及び第三者からの不正アクセス、ウイ
   ルスの感染等により、正常なサービスを提供することが困難である場合、又
   は困難であると当社が判断したとき
   (5) その他、当社が停止又は中断を必要であると判断した場合
2. 当社は、本条に基づき当社が行った措置に基づき専門家に生じた損害について責任を
負いません。

第10条（権利帰属）
1. 本サイト、本サービス及び関連するすべてのコンテンツに係る知的財産権は、当社又
は当社にライセンスを許諾している者に帰属するものとします。当社は、当該知的財
産権について、本規程又は特約等に基づき明示的に定める場合を除き、専門家に対し
て何らのライセンスを許諾するものではありません。
2. 専門家による前項のコンテンツの無断での複製、転載、二次利用その他の著作権法を
含む法令により禁止される行為が発見された場合、当社は法的措置をとる場合があり
ます。
3. 本条の規定に違反して専門家と第三者との間に紛争が生じた場合、専門家は、その責
任と費用において当該紛争を解決するとともに、当該紛争により当社に生じた一切の
損害（合理的な弁護士費用を含みます。）を賠償する責任を負うものとします。

第11条（利用停止措置等）
1. 当社は、専門家が以下の各号のいずれかの事由に該当する場合は、事前に通知又は催
告することなく、当該専門家について、本サービスの利用停止、専門家との契約の解
除、会員資格を取消し、当該会員資格に関する一切の情報の削除その他の当社が適当
と判断する措置を講ずることができるものとします。また、当社は、当該事由が生じ
た時点以降、当該専門家に対し、推奨手数料を支払う義務を負わないものとします。
   (1) 本規程又は特約等の各条項のいずれかに違反した場合
   (2) 当社が現在提供する又は過去に提供していたサービスに関し、専門家が、利用停
   止、会員資格取消しその他の措置を受けたことが判明した場合
   (3) 当社が現在提供する又は過去に提供していたサービスに関して、金銭の支払の遅
   延又は不能その他債務不履行をしていた場合
   (4) 支払停止若しくは支払不能となり、又は破産手続開始、民事再生手続開始、会社
   更生手続開始、特別清算開始若しくはこれらに類する手続の開始の申立てがあっ
   た場合
   (5) 第4条第3項各号のいずれかの事由に該当する場合
   (6) その他、前各号に準じる事由により、当社が専門家による本サービスの利用、専
   門家としての登録を適当でないと判断した場合
2. 前項各号のいずれかの事由に該当した場合、専門家は、当社に対して負っている債務
の一切について当然に期限の利益を失い、直ちに当社に対してすべての債務の履行を
行わなければなりません。
3. 当社は、本条に基づき当社が行った行為により専門家に生じた損害について、責任を
負いません。

第12条（退会）
1. 会員は、当社所定の手続の完了により、いつでも本サービスから退会し、会員登録を
取り消すことができます。
2. 前項に従い退会する会員は、退会にあたり、当社に対して負う一切の債務について当
然に期限の利益を失い、直ちに当社に対して全ての債務の履行を行わなければなりま
せん。

第13条（本サービスの内容の変更、終了）
1. 当社は、専門家の事前の承諾なくして、当社の都合により、本サービスの内容を変更
し、又は本サービスの提供を終了することができます。当社が本サービスの提供を終
了する場合、当社は専門家に対し事前に通知するものとします。
2. 当社は、前項に基づき当社が行った措置による専門家の不利益・損害に関して、責任
を負わないものとします。

第14条（保証の否認及び免責）
1. 当社は、本サービスが明文の規定に実質的に適合するように商業的に合理的な努力を
払うものとしますが、本サービスが、専門家の特定の目的に適合すること、期待する
機能・商品的価値・合法性・正確性・有用性・最新性を有すること、及び本サービス
の提供に不具合が生じないことについて、何ら保証するものではありません。本サー
ビスのご利用は、専門家ご自身の責任において行ってください。
2. 当社は、本サイトからリンクされた第三者が運営するサイトに関して、いかなる保証
もいたしません。また、専門家同士又はユーザーとのトラブルやリンク先で生じた損
害等に対し、当社は一切の補償及び関与をいたしません。
3. 本サービスを通じて販売される商品の品質、機能、性能その他の欠陥に関する当社の
責任は、当社の故意又は重過失による場合を除き、第10条第2項に定められるものに限
られます。
4. 当社は、当社による本サービスの提供の中断、停止、終了、利用不能又は変更、会員
資格の取消し、本サービスの利用による登録データの消失又は機器の故障若しくは損
傷、当社が専門家に提供する情報や推奨連絡に関する情報の削除又は消失、その他本
サービスに関して専門家が被った損害（会員としての立場によるものを含みます。）
につき、賠償する責任を負わないものとします。
5. 当社は、故意又は重過失がない限り、本サービス又は本規程に関して一切の責任を負
わないものとします。また、当社が責任を負う場合であっても、当社は、債務不履行
又は不法行為により専門家が被った、付随的損害、間接損害、特別損害、将来の損害
及び逸失利益にかかる損害については責任を負わないものとし、本サービス又は本規
程に関連して当社が負う損害賠償の累計総額は、理由の如何を問わず、直近３か月以
内に当社が本サービス又は本規程に基づき専門家に対し実際に支払った推奨手数料の
総額を上限とします。
6. 本サービスに関連して（専門家からユーザーに対する推奨連絡に関するものを含みま
す。）専門家とユーザーその他の第三者との間において生じた取引、連絡、紛争等に
ついては、専門家が自己の責任によって解決するものとし、当社は一切責任を負いま
せん。

第15条（秘密保持）
専門家は、当社が専門家に対して秘密に取り扱うことを求めて開示した本サービスに関す
る非公知の情報について、当社の事前の書面による承諾がない限り、秘密に取り扱わなけ
ればならないものとします。

第16条（個人情報の取扱い）
1. 当社は、専門家の情報を、別途定める当社のプライバシーポリシー（
https://www.hills.co.jp/legal-statement-and-privacy-policy）に従い取り扱うこととし、専門
家はこのプライバシーポリシーに従って当社が専門家の情報を取扱うことについて同
意するものとします。
2. 専門家は、本サービスにおいて提供を受けたユーザー（対象ユーザーを含みます。）
の個人情報を、法令及びガイドラインに従い取り扱うものとし、第三者に漏えい、滅
失または毀損等（以下「漏えい等」といいます。）してはならず、専門家がユーザー
に対してあらかじめ明示した目的以外の目的で利用してはなりません。また、販売事
業者は、プライバシーポリシーを定めるとともに、個人情報の取扱いについて法令上
要求される安全管理措置を講じる義務を自ら負うものとします。
3. 専門家は、専門家又はその委託先からユーザーの情報が漏えい等した場合、直ちに当
社に対し通知するとともに、自らの責任および費用においてこれに対処しなければな
らないものとします。また、専門家は、当該漏えい等によって当社に損害が生じたと
きは、当該損害及び費用（弁護士費用を含みます。）を賠償するものとします。

第17条（本規程の変更）
当社は、当社の裁量により本規程を変更できるものとし、本規程の変更の効力は、当社が
定める効力発生日から生じるものとします。当社は、本規程を変更する場合には、本規程
を変更する旨及び当該変更内容並びにその効力発生日を、本サイトでの掲示その他の適切
な方法により周知するものとします。

第18条（通知・連絡）
1. 本サービスに関する問い合わせその他専門家から当社に対する連絡又は通知その他当
社から専門家に対する連絡又は通知は、当社の定める方法により行うものとします。
2. 専門家が当社に対し登録事項を提供した場合には、当社が登録事項に含まれるメール
アドレスその他の連絡先に連絡又は通知の発送を行ったときに、当該連絡又は通知が
完了したものとみなします。

第19条（地位等の譲渡）
1. 専門家は、本規程に基づく契約上の地位又は権利義務を、当社の書面による事前の承
諾なく、第三者に対して、譲渡、移転、担保設定、その他の処分をすることはできま
せん。
2. 当社は本サービスに関する事業を第三者に譲渡した場合には、当該事業譲渡に伴い、
本規程に基づく契約上の地位、本規程に基づく権利、義務、専門家の登録事項その他
の専門家の情報等を、当該事業譲渡の譲受人に譲渡又は引き渡すことができるものと
し、専門家は、かかる譲渡等について本項において予め同意したものとします。なお
、本項に定める事業譲渡には、通常の事業譲渡のみならず、会社分割その他事業が移
転するあらゆる場合を含みます。

第20条（分離可能性）
本規程のいずれかの条項又はその一部が、法令に基づいて無効又は執行不能と判断された
場合でも、本規程のその他の規定及び一部が無効又は執行不能と判断された規定の残りの
部分は、継続して完全に有効とします。

第21条（準拠法及び裁判管轄）
1. 本規程は、日本法に基づき解釈されるものとします。
2. 本規程に関して訴訟の必要が生じた場合には、東京地方裁判所を第一審の専属的合意
管轄裁判所とします。



2022年11月8日制定`}
  </div>
);

export default Before20250701Terms;
